import { css } from 'styled-components';

export default css`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
  }
`;
